import type {AppPlatform, DeviceType, FileDescriptorDto} from "../../api/artifacts";

export const PAGE_SIZE = 10;
export const FIRMWARE_TABLE_HEIGHT = 420;

export const DEVICE_TYPE_LABELS: Record<DeviceType, string> = {
  ClockMechanicE: "Часовой механизм iTitan.M (BC-MCH-05)",
  ClockMechanicN: "Часовой механизм iNunki.N (BC-NU-90A)",
  ClockMechanicV: "Часовой механизм iNaos.X (BC-MN-A1|B1|C1)",
  UpsI: "Бесперебойник iSentinel.Z (BC-SP-1)",
  ElectronicClock: "Цифровые часы iElectra.E",
  DimmerD: "Управление светом iAltair.D (BC-BUS-06)",
  DimmerS: "Управление светом iAltair.S (BC-BUS-02)",
  SensorBlockT: "Блок датчиков iVega.W (BC-BDT-1)",
  LedPanel: "LED-панель",
};

export const DEVICE_TYPE_SHORT_LABELS: Record<DeviceType, string> = {
  ClockMechanicE: "iTitan.M",
  ClockMechanicN: "iNunki.N",
  ClockMechanicV: "iNaos.X",
  UpsI: "iSentinel.Z",
  ElectronicClock: "iElectra.E",
  DimmerD: "iAltair.D",
  DimmerS: "iAltair.S",
  SensorBlockT: "iVega.W",
  LedPanel: "LED-панель",
};

export const DEVICE_TYPE_OPTIONS: Array<{label: string; value: DeviceType}> = [
  {label: DEVICE_TYPE_LABELS.DimmerD, value: "DimmerD"},
  {label: DEVICE_TYPE_LABELS.ElectronicClock, value: "ElectronicClock"},
  {label: DEVICE_TYPE_LABELS.UpsI, value: "UpsI"},
  {label: DEVICE_TYPE_LABELS.ClockMechanicE, value: "ClockMechanicE"},
  {label: DEVICE_TYPE_LABELS.ClockMechanicN, value: "ClockMechanicN"},
  {label: DEVICE_TYPE_LABELS.DimmerS, value: "DimmerS"},
  {label: DEVICE_TYPE_LABELS.SensorBlockT, value: "SensorBlockT"},
  {label: DEVICE_TYPE_LABELS.ClockMechanicV, value: "ClockMechanicV"},
  {label: DEVICE_TYPE_LABELS.LedPanel, value: "LedPanel"},
];

export const ESP_TYPE_OPTIONS: Array<{label: string; value: string}> = [
  {label: "Не определено", value: "Undefined"},
  {label: "Almaaz", value: "Almaaz"},
  {label: "Atlas", value: "Atlas"},
  {label: "Astra", value: "Astra"},
  {label: "Atria", value: "Atria"},
];

export const APP_PLATFORM_OPTIONS: Array<{label: string; value: AppPlatform}> = [
  {label: "Android", value: "Android"},
  {label: "iOS", value: "iOS"},
  {label: "Web", value: "Web"},
];

export const CLOCK_STATION_MODEL_OPTIONS: Array<{label: string; value: string}> = [
  {label: "ЧС-БК-GPS-М2К iAlmaaz", value: "ALMAAZ_M2K"},
  {label: "ЧС-БК-GPS-М4К iAlmaaz", value: "ALMAAZ_M4K"},
  {label: "ЧС-БК-GPS-4К iAlmaaz", value: "ALMAAZ_4K"},
  {label: "ЧС-БК-GPS-2К iAlmaaz", value: "ALMAAZ_2K"},
  {label: "ЧС-БК-GPS-М4К iAstra", value: "ASTRA_M4K"},
  {label: "ЧС-БК-GPS-М2К iAstra", value: "ASTRA_M2K"},
  {label: "ЧС-БК-GPS-4К iAstra", value: "ASTRA_4K"},
  {label: "ЧС-БК-GPS-2К iAstra", value: "ASTRA_2K"},
  {label: "ЧС-БК-GPS-2К iAtlas", value: "ATLAS_2K"},
  {label: "ЧС-БК-GPS-4К iAtlas", value: "ATLAS_4K"},
  {label: "ЧС-БК-GPS-М2К iAtlas", value: "ATLAS_M2K"},
  {label: "ЧС-БК-GPS-М4К iAtlas", value: "ATLAS_M4K"},
];

export type FirmwareItem = {
  id?: string;
  version?: string | null;
  description?: string | null;
  deviceType?: DeviceType;
  fileDescriptor?: FileDescriptorDto;
  isDeployedToTest?: boolean;
  isDeployedToProduction?: boolean;
  deployedToTestAt?: string | null;
  deployedToProductionAt?: string | null;
  createdBy?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
};

export type FirmwaresResponse = {
  items?: FirmwareItem[] | null;
  data?: FirmwareItem[] | null;
  totalCount?: number;
};

export type EspFirmwareItem = {
  id?: string;
  version?: string | null;
  description?: string | null;
  espType?: string | null;
  fileDescriptor?: FileDescriptorDto;
  isDeployedToTest?: boolean;
  isDeployedToProduction?: boolean;
  deployedToTestAt?: string | null;
  deployedToProductionAt?: string | null;
  createdBy?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
};

export type EspFirmwaresResponse = {
  items?: EspFirmwareItem[] | null;
  data?: EspFirmwareItem[] | null;
  totalCount?: number;
};

export type AppChangelogItem = {
  id?: string;
  version?: string | null;
  description?: string | null;
  platform?: AppPlatform;
  createdBy?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
};

export type AppChangelogsResponse = {
  items?: AppChangelogItem[] | null;
  data?: AppChangelogItem[] | null;
  totalCount?: number;
};

export type ClockStationFirmwareItem = {
  id?: string;
  version?: string | null;
  description?: string | null;
  model?: string | null;
  modelType?: string | null;
  channels?: number | null;
  melody?: boolean | null;
  customMelodyEffect?: boolean | null;
  fileDescriptor?: FileDescriptorDto;
  createdBy?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
};

export type ClockStationFirmwaresResponse = {
  items?: ClockStationFirmwareItem[] | null;
  data?: ClockStationFirmwareItem[] | null;
  totalCount?: number;
};

export type FirmwareModalMode = "create" | "edit";

export type FirmwareModalProps = {
  open: boolean;
  mode: FirmwareModalMode;
  firmware?: FirmwareItem | null;
  onClose: () => void;
  onSuccess: () => void;
};

export type FirmwareFormState = {
  version: string;
  description: string;
  deviceType: DeviceType | null;
  file: Blob | null;
};

export type EspFirmwareModalProps = {
  open: boolean;
  mode: FirmwareModalMode;
  firmware?: EspFirmwareItem | null;
  onClose: () => void;
  onSuccess: () => void;
};

export type EspFirmwareFormState = {
  version: string | null;
  description: string;
  espType: string | null;
  file: Blob | null;
};

export type ClockStationFirmwareModalProps = {
  open: boolean;
  mode: FirmwareModalMode;
  firmware?: ClockStationFirmwareItem | null;
  onClose: () => void;
  onSuccess: () => void;
};

export type ClockStationFirmwareFormState = {
  version: string | null;
  description: string;
  model: string;
  modelType: string | null;
  channels: number | null;
  melody: boolean | null;
  customMelodyEffect: boolean | null;
  file: Blob | null;
};

export type AppChangelogModalProps = {
  open: boolean;
  mode: FirmwareModalMode;
  changelog?: AppChangelogItem | null;
  onClose: () => void;
  onSuccess: () => void;
};

export type AppChangelogFormState = {
  version: string;
  description: string;
  platform: AppPlatform | null;
};

export type FirmwareAction = "deployTest" | "deployProduction" | "removeFromTest" | "removeFromProduction" | "delete";

export type FirmwareModalTab = "general" | "history";

export type FirmwareHistoryItem = {
  id?: string;
  action?: string | null;
  comment?: string | null;
  performedBy?: string | null;
  createdAt?: string | null;
};

export type FirmwareActionConfig = {
  title: string;
  message: string;
  confirmText: string;
  color: "blue" | "green" | "red";
};

export const actionConfigs: Record<FirmwareAction, FirmwareActionConfig> = {
  deployTest: {
    title: "Подтверждение деплоя",
    message: "Выполнить деплой прошивки на Test?",
    confirmText: "Деплой на Test",
    color: "blue",
  },
  deployProduction: {
    title: "Подтверждение деплоя",
    message: "Выполнить деплой прошивки на One?",
    confirmText: "Деплой на One",
    color: "blue",
  },
  removeFromTest: {
    title: "Подтверждение снятия с контура",
    message: "Снять прошивку с Test?",
    confirmText: "Снять с Test",
    color: "blue",
  },
  removeFromProduction: {
    title: "Подтверждение снятия с контура",
    message: "Снять прошивку с One?",
    confirmText: "Снять с One",
    color: "blue",
  },
  delete: {
    title: "Подтверждение удаления",
    message: "Удалить прошивку? Это действие нельзя отменить.",
    confirmText: "Удалить",
    color: "red",
  },
};

export type FirmwareTab = "devices" | "esp" | "app" | "clockStation";
